module.exports = __webpack_public_path__ + "img/shirt_sad.a9433824.gif";